















































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import { DraftOrder } from '@/models';

import PriceBlock from '@/components/PriceBlock.vue';

@Component({
  components: {
    PriceBlock,
  },
  props: {
    order: {
      type: DraftOrder,
      required: true,
    },
  },
})
export default class OrderSummary extends Vue { }

